module.exports = __webpack_public_path__ + "img/guava.d328a43b.jpg";